<template>
  <div class="input-textlist">
    <multiselect
      v-model="currentValue"
      :options="textListOptions"
      :multiple="field.isArray || false"
      :close-on-select="!field.isArray"
      :clear-on-select="true"
      :preserve-search="true"
      :preselect-first="false"
      :allow-empty="!field.required"
      :searchable="true"
      :show-labels="true"
      :disabled="disabled"
      label="label"
      track-by="_id"
      :placeholder="placeholder"
    >
      <template #selection="{ option }">
        <span v-if="option">
          {{ option.label }}
          <span
            v-if="!field.isArray"
            class="multiselect__tag-icon"
            @click.stop="onRemove"
          ></span>
        </span>
      </template>
    </multiselect>

    <!-- Vista previa usando ViewTextList -->
    <div v-if="showPreview && value && field.key == 'status'" class="mt-2">
      <small class="text-muted">Preview:</small>
      <ViewTextList
        :field="field"
        :value="getPreviewValue"
        :modelName="modelName"
      />
    </div>
  </div>
</template>

<script>
import { ViewTextList } from "../views";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

export default {
  name: "InputTextList",
  components: {
    ViewTextList,
    Multiselect,
  },
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      type: [String, Array, Object],
      default: null,
    },
    modelName: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
    showPreview: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "Select an option",
    },
  },
  computed: {
    textListOptions() {
      return this.getTextListOptions(this.field);
    },
    currentValue: {
      get() {
        // Si hay un valor, convertirlo al formato correcto si es necesario
        if (
          this.value !== null &&
          this.value !== undefined &&
          this.value !== ""
        ) {
          return this.formatValue(this.value);
        }
        // Si no hay valor pero hay defaultValue, convertirlo al formato correcto
        if (
          this.field.defaultValue !== null &&
          this.field.defaultValue !== undefined &&
          this.field.defaultValue !== ""
        ) {
          return this.formatValue(this.field.defaultValue);
        }
        // Si no hay ni valor ni defaultValue, retornar null
        return null;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
    getPreviewValue() {
      // Si el valor es un objeto con _id, usar solo el _id
      if (this.value && typeof this.value === "object" && this.value._id) {
        return this.value._id;
      }
      // Si es un array de objetos, extraer los _id
      if (Array.isArray(this.value)) {
        return this.value.map((item) =>
          typeof item === "object" && item._id ? item._id : item
        );
      }
      // Si es un string o número, usarlo directamente
      return this.value;
    },
  },
  methods: {
    getTextListOptions(field) {
      if (!field.options) return [];

      if(Array.isArray(field.options)){
        field.options = field.options[0];
      }

      // Dividir por | o , y limpiar espacios
      const options = field.options
        .split(/\s*[|,]\s*/)  // separa por | o , con posibles espacios alrededor
        .map((option) => option.trim())
        .filter((option) => option);

      return options.map((option) => ({
        _id: option,
        label: this.$t(option),
      }));
    },
    formatValue(value) {
      // Si ya es un objeto con _id y label, retornarlo tal como está
      if (value && typeof value === "object" && value._id && value.label) {
        return value;
      }

      // Si es un array de objetos, retornarlo tal como está
      if (Array.isArray(value)) {
        return value;
      }

      // Si es un string o número, convertirlo al formato de objeto
      if (value !== null && value !== undefined && value !== "") {
        return {
          _id: value,
          label: this.$t(value),
        };
      }

      // Si es null, undefined o vacío, retornar null
      return null;
    },
  },
};
</script>

<style scoped>
.input-textlist {
}

.form-label {
  font-weight: 500;
  color: #495057;
  margin-bottom: 8px;
}

.text-danger {
  color: #dc3545;
}

.text-muted {
  color: #6c757d;
  font-size: 0.875rem;
}

/* Estilos específicos para multiselect */
.multiselect {
  min-height: 40px;
  border: 1px solid #ced4da;
  border-radius: 4px;
}

.multiselect__tags {
  min-height: 40px;
  padding: 8px 23px 0 8px;
  border-radius: 4px;
  background: #fff;
}

.multiselect__input {
  border: none;
  background: transparent;
  padding: 0;
  margin: 0;
  min-height: 20px;
}

.multiselect__placeholder {
  color: #6c757d;
  margin-bottom: 0;
  padding-top: 0;
  padding-bottom: 0;
}

.multiselect__content-wrapper {
  border: 1px solid #ced4da;
  border-top: none;
  background: #fff;
  border-radius: 0 0 4px 4px;
  max-height: 200px;
  overflow-y: auto;
}

.multiselect__option {
  padding: 8px 12px;
  cursor: pointer;
}

.multiselect__option--highlight {
  background: #007bff;
  color: #fff;
}

.multiselect__option--selected {
  background: #e9ecef;
}

.multiselect__tag-icon {
  cursor: pointer;
}
</style>
